export default __webpack_public_path__ + "static/media/project_lg_autopartes_blur.62140411.png";